function formatEstimatedWaitTime(estimatedWaitMs: number) {
  const estimatedWaitSecs = estimatedWaitMs / 1000;
  if (estimatedWaitSecs < 60) {
    return '< 1 min';
  }
  const mins = Math.floor(estimatedWaitSecs / 60);
  const seconds = estimatedWaitSecs % 60;
  if (seconds === 0) {
    return `${mins} min`;
  }
  return `${mins} min ${seconds} sec`;
}

export default formatEstimatedWaitTime;
